var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{staticClass:"space-bottom big-title"},[_vm._v("Más de 50.000 solicitudes y USD$ 40MM de hipotecas originadas.")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_vm._v("Nuestro proceso es rápido y conveniente.")])])
}]

export { render, staticRenderFns }